import { getToolTipAttributes } from "../../../utils/tooltip";

const AVATAR_COLORS = ["#1558BC", "#007bff", "#6f42c1", "#fd7e14", "#f39c12", "#17a2b8"];

const getInitials = (name) => {
  if (!name) return "U";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const getAvatarColor = (name) => {
  if (!name) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash % AVATAR_COLORS.length);
  return AVATAR_COLORS[index];
};

const UserAvatar = ({ name }) => {
  const isPremium = name && name.toLowerCase().trim() === PREMIUM_USER;

  const standardStyle = {
    backgroundColor: getAvatarColor(name),
    border: "2px solid white",
    color: "#fff"
  };

  const premiumStyle = {
    background: "linear-gradient(135deg, #FFD700 0%, #D4AF37 50%, #B8860B 100%)",
    border: "2px solid #FFF8DC",
    boxShadow: "0 0 10px rgba(255, 215, 0, 0.6)",
    color: "#fff",
    textShadow: "0px 1px 2px rgba(0,0,0,0.5)"
  };

  const activeStyle = isPremium ? premiumStyle : standardStyle;

  return (
    <div style={{ position: "relative", display: "inline-flex" }}>
      <div
        className="d_flex justify_center align_center border_radius_circle color_light font_size_xsmall font_weight_bold cursor_default"
        style={{
          width: "28px",
          height: "28px",
          minWidth: "28px",
          fontSize: "10px",
          borderRadius: "50%",
          ...activeStyle
        }}
        {...getToolTipAttributes(name)}
      >
        {getInitials(name)}
      </div>
    </div>
  );
};

const PREMIUM_USER = "vamsi kartik";

export default UserAvatar;
